import React, { useEffect } from "react";
import { APP_THEME } from "../theme/theme";
import { apiCall } from "../utils/api";
import { useNavigate } from "react-router-dom";

function PreLoading() {
    const navigate = useNavigate();
    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const result = await apiCall(
                    "balance",
                    {},
                    true
                );
                if (result.status === true) {
                    localStorage.setItem("balance", result.data.balance);
                    navigate("/home", { replace: true });
                } else {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace("/login");
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchBalance();
    }, []);

    return (
        <div className="flex items-center justify-center h-screen w-full bg-white">
            <div
                className="w-12 h-12 rounded-full border-4 border-gray-200 animate-spin"
                style={{
                    borderTopColor: APP_THEME.primaryColor,
                }}
            />
        </div>
    );
}

export default PreLoading;